import { getCookie } from '../cookies'
import { OLD_SELLER_URL } from '@/resources/enums/miscellaneous'

export const getTokenExpirationTime = token => {
  try {
    const base64Url = token.split('.')[1]
    const base64Text = base64Url?.replace('-', '+')?.replace('_', '/')
    const { exp: expirationTime = 0 } = JSON.parse(
      window.atob(base64Text) ?? '{}'
    )
    return expirationTime
  } catch {
    return 0
  }
}

export const identifyHeroHelpUser = async () => {
  if (window.HelpHero !== undefined) {
    try {
      await window.HelpHero.identify(getCookie('email'))
      // eslint-disable-next-line no-empty
    } catch {}
  }
}

export const userArrivedFromTheOldPlatform = () =>
  document.referrer === OLD_SELLER_URL
